import { get, isEqual } from 'lodash'

import { shouldPrompt } from 'common/non-collegiate-outcome-type'

export default {
  OUTCOMES: (user, profile, prospects) =>
    shouldPrompt(
      isEqual(get(user, 'HighSchool.CurrentSeniorYear'), get(profile, 'GraduationYear')),
      user.NonCollegiateOutcomeType,
      prospects,
      get(user, 'HighSchool.CurrentSeniorYear'),
    ),
}
